import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'
const routes = [
    {
        path: '/supplier',
        name: 'supplier',
        meta: { title: '供应商管理' },
        redirect: '/supplier/lists',
        component: Main,
        children: [
            {
                path: '/supplier/lists',
                name: 'supplier_lists',
                meta: {
                    title: '供应商列表',
                    parentPath: '/supplier',
                    icon: 'icon_ziti_store',
                    permission: ['view']
                },
                component: () => import('@/views/supplier/lists/index.vue')
            },
            {
                path: '/supplier/commodity',
                name: 'commodity',
                meta: {
                    title: '供应商商品',
                    parentPath: '/supplier',
                    icon: 'icon_ziti_store',
                    permission: ['view']
                },
                component: () => import('@/views/supplier/commodity/index.vue')
            },
            {
                path: '/supplier/commodityDetail',
                name: 'supplier_commodityDetail',
                meta: {
                    title: '供应商商品详情',
                    parentPath: '/supplier',
                    prevPath: '/supplier/commodity',
                    icon: 'icon_ziti_store',
                    hidden: true,
                    permission: ['view']
                },
                component: () => import('@/views/supplier/commodity/kprelease.vue')
            },
            {
                path: '/supplier/order',
                name: 'supplier_order',
                meta: {
                    title: '供应商订单',
                    parentPath: '/supplier',
                    icon: 'icon_ziti_store',
                    permission: ['view']
                },
                component: () => import('@/views/supplier/order/index.vue')
            },
            {
                path: '/supplier/settle',
                name: 'supplier_settle',
                meta: {
                    title: '供应商结算',
                    parentPath: '/supplier',
                    icon: 'icon_ziti_store',
                    permission: ['view']
                },
                component: () => import('@/views/supplier/settle.vue')
            },
            {
                path: '/supplier/orderDetail',
                name: 'supplier_order',
                meta: {
                    title: '订单详情',
                    hidden: true,
                    parentPath: '/supplier',
                    icon: 'icon_ziti_store',
                    prevPath: '/supplier/order',
                    permission: ['view']
                },
                component: () => import('@/views/supplier/order/detail.vue')
            }
        ]
    }
]

export default routes
